var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftHeading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5005 2.16238V11.4813C13.5005 11.8154 13.2717 12.0865 12.9898 12.0865H7.76461C7.48267 12.0865 7.25391 11.8154 7.25391 11.4813V11.3312H10.0906C10.5524 11.3312 10.9301 10.8835 10.9301 10.3363V1.55713H12.9898C13.2717 1.55713 13.5005 1.82824 13.5005 2.16238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24659 11.3315V11.4865C6.24659 11.8217 6.01867 12.0918 5.73166 12.0918H0.510701C0.22876 12.0918 0 11.8207 0 11.4865V2.16763C0 1.83349 0.22876 1.56238 0.510701 1.56238H2.57461V10.334C2.57461 10.8848 2.95151 11.3315 3.41621 11.3315H6.24659Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04629 0.0917969H9.43397C9.73744 0.0917969 9.98393 0.383919 9.98393 0.743569V9.67231C9.98393 10.032 9.73744 10.3236 9.43439 10.3236H4.04629C3.74282 10.3236 3.49634 10.0315 3.49634 9.67181V0.743569C3.49634 0.383919 3.74282 0.0917969 4.04629 0.0917969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftHeading);
export default __webpack_public_path__ + "static/media/nft-heading.6ac0d0a4d4bfd90d186cce302ce36c29.svg";
export { ForwardRef as ReactComponent };